import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './boletines.css';
import { boletines_item } from '../../json/boletines';

const Boletines = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <div className='container transparencia-container'>
        <div className='row'>
            <div className='col_12'>
                <div className='transparencia_title'>
                    <h1>Boletines</h1>
                </div>
            </div>
        </div>
        <div className='row'>
            {
                boletines_item.map((item, index)=>(
                    <div key={ index } className='col-md-4 col-sm-6 col-12 transparencia_item'>
                        <Link target='_black' to={ item.boletines_item_url }><b>{ item.boletines_item_titulo }</b> </Link>{ item.boletines_item_nombre }
                    </div>
                ))
            }
        </div>
    </div>
  )
}

export default Boletines